import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const setChangeEmailWidgetEmail = createAction(
  `${reduxKey}.SET_CHANGEEMAIL_WIDGET_EMAIL`,
  (email: string) => ({ email })
);

export const setChangeEmailWidgetPassword = createAction(
  `${reduxKey}.SET_CHANGEEMAIL_WIDGET_PASSWORD`,
  (password: string) => ({ password })
);

export const saveChangeEmail = createAction(
  `${reduxKey}.SAVE_CHANGEEMAIL`,
  () => ({})
);

export const saveChangeEmailSuccess = createAction(
  `${reduxKey}.SAVE_CHANGEEMAIL_SUCCESS`,
  () => ({})
);

export const saveChangeEmailFailure = createAction(
  `${reduxKey}.SAVE_CHANGEEMAIL_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
